import React, { Fragment } from "react";
import { Button } from "antd";

const BtnFormSubmit = ({ onClick, disabled }) => {
  return (
    <Fragment>
      <Button
        disabled={disabled}
        type="primary"
        htmlType="submit"
        size="large"
        className="offer-card-btn"
        onClick={onClick}
      >
        Создать предложение
      </Button>
    </Fragment>
  );
};

export default BtnFormSubmit;
